<template>
  <span
    class="draggableImageItem"
    :class="picItem.actState"
    :style="computedPicItemStyle"
  >
    <img :src="picItem.urlBase64 ? picItem.urlBase64 : picItem.url" />
    <!-- <span
            class="img"
            :style="{ backgroundImage: `url(${picItem.url})` }"
          ></span> -->
  </span>
</template>
<script>
// 数据海报中的 指标项主题
export default {
  name: 'draggableImageItem',
  props: {
    currThemeObj: {
      type: Object,
      default: null,
    },
    picItem: {
      type: Object,
      default: () => ({
        picRateW: 0,
        picRateH: 0,
        useScale: 1,
      }),
    },
    cssDynamicObj: {
      type: Object,
      default: () => ({
        mixvw: 1,
        mixvh: 1,
        realyWidth: 0,
        realyHeight: 0,
      }),
    },
  },
  watch: {
    picItem(newVal, oldVal) {
      console.debug('picItem:', newVal, oldVal)
      if (newVal && JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
      }
    },
    immediate: true,
    deep: true,
  },
  data() {
    return {}
  },
  computed: {
    computedPicItemStyle() {
      console.debug('computedPicItemStyle', this.picItem)
      return {
        width: `${
          this.cssDynamicObj.realyWidth *
          this.picItem.picRateW *
          this.picItem.useScale
        }px`,
        height: `${
          this.cssDynamicObj.realyHeight *
          this.picItem.picRateH *
          this.picItem.useScale
        }px`,
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.draggableImageItem {
  position: relative;
  &.click {
    &::before {
      border: 1px solid var(--mixtmt_mainColor);
    }
  }
  &.longPress {
    &::before {
      background-color: var(--mixtmt_greyColor5);
      border: 1px solid var(--mixtmt_subColor1_1);
    }
  }
  img {
    display: block;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
  .img {
    display: block;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
  }
  &::before {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    content: '\20';
    pointer-events: none;
    width: 100%;
    height: 100%;
    border: 0;
  }
}
</style>
